import styles from './WineSamplesLink.module.scss';
import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import {FC} from 'react';

interface IProps {
    href: string;
}

export const WineSamplesLink: FC<IProps> = ({href}) => {
    return (
        <a href={href} className={styles.wineTastingLink}>
            <img src={'/images/events-page/winesample.webp'} alt={'Бесплатные винопробы'} />
            <Typography className={styles.wineTastingText} variant={'label-14-m'}>
                Бесплатные винопробы
            </Typography>
            <Icon icon={'arrow'} />
        </a>
    );
};
